import { initEventOrganisationDataStorage } from '../eventOrganisationDataStorage.js';

const eventOrganisationDataStorage = initEventOrganisationDataStorage();

/**
 * Get the photo share domain from event organisation data storage
 * Falls back to environment variable if not available
 *
 * @returns {string} The photo share domain URL
 */
export function getPhotoShareDomain() {
  return eventOrganisationDataStorage.hasPhotoShareDomain()
    ? eventOrganisationDataStorage.getPhotoShareDomainFromStorage()
    : process.env.WEBAPP_SHARED_URL;
}

/**
 * Get the webapp domain from event organisation data storage
 * Falls back to environment variable if not available
 *
 * @returns {string} The webapp domain URL
 */
export function getWebappDomain() {
  return eventOrganisationDataStorage.hasWebappDomain()
    ? eventOrganisationDataStorage.getWebappDomainFromStorage()
    : process.env.WEBAPP_URL;
}
/**
 * Transform an S3 URL to use the photo share domain
 *
 * @param {string} s3Url - The S3 URL to transform
 * @returns {string} The transformed URL using photo share domain
 */
export function transformS3UrlToShareDomain(s3Url) {
  if (!s3Url) return s3Url;

  const photoShareDomain = getPhotoShareDomain();

  // Extract the path from the S3 URL (everything after the domain)
  const url = new URL(s3Url);
  const path = url.pathname;

  // Return the photo share domain with the same path
  return `${photoShareDomain}${path}`;
}
